"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var XeThemeV1Colors = {
  grey: {
    "default": "#000000",
    boulder: "#757575",
    silver: "#c7c6c6",
    mercury: "#e9e8e7",
    alabaster: "#f8f8f8",
    fuscous: "#434341"
  },
  blue: {
    "default": "#002272",
    endeavour: "#015B9D",
    science: "#005ecf",
    malibu: "#71c4ff",
    frenchpass: "#B1D7FE",
    cornflower: "#71C4FF",
    blueribbon: "#005CEF",
    nightblue: "#182E7E",
    uniform: "#37488F",
    aquablue: "#00E1FF"
  },
  purple: {
    "default": "#4A4096"
  },
  yellow: {
    "default": "#fcb813",
    hover: "#fcb813",
    hover_old: "#fcea10"
  },
  green: {
    "default": "#00ae00",
    fun: "#026825"
  },
  red: {
    "default": "#f00000",
    redVermilion: "#f54305"
  },
  white: {
    "default": "#ffffff"
  },
  black: {
    "default": "#000000"
  },
  transparent: {
    "default": "transparent"
  },
  gradient: {
    "default": "linear-gradient(90deg, #182E7E, #37488F, #4A4096)"
  }
};
var _default = XeThemeV1Colors;
exports["default"] = _default;